import { classifyVoiceIntent, startsDistinctAction } from './voiceIntent';
import { captureSchedule } from './voiceSchedule';
export { captureSchedule } from './voiceSchedule';

export function planVoiceCapture(transcript, reference = new Date()) {
  const original = transcript.trim();
  const fragments = []; let cursor = 0;
  // A separator is only a candidate. The next clause must begin a distinct
  // action/event; person names and product lists are not split at every 'and'.
  const separators = /[,;]\s*|\s+(?:and then|and also|and|then|also|plus)\s+|[.!?]\s+/gi;
  for (const match of original.matchAll(separators)) {
    const next = match.index + match[0].length;
    const left = original.slice(cursor, match.index).trim();
    const right = original.slice(next).replace(/^(?:and\s+)?(?:then\s+)?/i, '');
    if (!left || !startsDistinctAction(right)) continue;
    // Quoted content and a second attendee are not new actions.
    if ((original.slice(0, match.index).match(/"/g) || []).length % 2 === 1) continue;
    if (/\b(?:lunch|dinner|meeting|call|coffee) with\b/i.test(left) && /^(?:doctor|dr\.?)\s+[A-Z]/.test(right) && !/\b(?:appointment|visit)\b/i.test(right)) continue;
    // Do not sever an action from a date-only lead-in: 'Tomorrow, call Jim'.
    if (!startsDistinctAction(left) && classifyVoiceIntent(left).confidence === 'low') continue;
    fragments.push(left);
    cursor = next;
  }
  fragments.push(original.slice(cursor).trim());
  let parts = fragments.filter(Boolean);
  // Once a boundary has been proven to start a distinct action, remove only
  // its connective words. Never trim names/objects or alter an unsplit note.
  if (parts.length > 1) parts = parts.map((part, index) => index === 0 ? part : part.replace(/^(?:(?:and|then|also|plus)\s+)+/i, '').trim());
  let fallback = parts.length > 10;
  const firstSchedule = captureSchedule(parts[0] || original, reference);
  if (parts.length > 1 && firstSchedule.uncertain && !firstSchedule.ambiguousMeridiem) fallback = true;
  if (fallback) parts = [original];
  const items = parts.map(text => {
    const intent = classifyVoiceIntent(text);
    const schedule = captureSchedule(text, reference);
    if (schedule.uncertain) intent.needsReview = true;
    return { text, intent, schedule };
  });
  if (fallback) items[0].intent.needsReview = true;
  return { original, items, firstSchedule, reference, needsReview: fallback };
}